import { FC } from "react";
import { useTranslation } from "react-i18next";
import { List, ListItem, ListItemText } from "@mui/material";
import styles from "@/components/company/batchCreate/companiesWithoutQueuedMailList.module.css";

export interface CompanyWithoutQueuedMail {
  company_id: string;
  company_subject_id: string;
  company_name: string;
  reasons: string[];
}

interface CompaniesWithoutQueuedMailListProps {
  companies: CompanyWithoutQueuedMail[];
}

const CompaniesWithoutQueuedMailList: FC<
  CompaniesWithoutQueuedMailListProps
> = ({ companies }) => {
  const { t } = useTranslation();

  if (companies.length === 0) {
    return null;
  }

  return (
    <section className={styles.container}>
      <p className={styles.heading}>{t("companies_without_queued_mail")}:</p>
      <List dense className={styles.list}>
        {companies.map((company) => (
          <ListItem key={company.company_id} className={styles.listItem}>
            <ListItemText
              primary={
                <a
                  href={`/admin/userAdministration/${company.company_subject_id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.companyLink}
                >
                  {company.company_name}
                </a>
              }
              secondary={company.reasons
                .map((reason) => t(`mail_not_queued_reason_${reason}`))
                .join(", ")}
              secondaryTypographyProps={{ color: "error" }}
            />
          </ListItem>
        ))}
      </List>
    </section>
  );
};

export default CompaniesWithoutQueuedMailList;
